import Penpal from 'penpal'
import ResizeObserver from 'resize-observer-polyfill'
import store from '@/store'

let penpalParent = null

if (parent !== window) {
  const connection = Penpal.connectToParent({
    methods: {
      parentUrl: (url) => {
        store.commit('app/ROOTURL_UPDATED', url)
      },
      documentHeight: () => {
        return document.body.offsetHeight
      }
    }
  })

  connection.promise.then(parent => {
    penpalParent = parent

    const ro = new ResizeObserver((entries, observer) => {
      for (const entry of entries) {
        let { height } = entry.contentRect
        parent.resize(height)
      }
    })
    ro.observe(document.querySelector('#app'))
  })
}

const sendInfo = (emiter, data) => {
  if (penpalParent) {
    penpalParent[emiter](data)
  }
}

export {
  sendInfo
}
